import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const AVIATION_DOMAIN_INTRO = {
  title: "Aviation & Aerospace",
  content: "Agentic AI workflow automation for Aviation & Aerospace — across MRO, Airlines, and Aviation Safety. Use cases span MRO work order planning, crew rostering support, and safety incident report summarization. Practical deployments for airlines and MRO providers in India, UAE, KSA, UK, and USA with human-in-the-loop review, status tracking, and audit evidence.",
  seoDescription: "Aviation aerospace agentic AI — MRO work order planning, crew rostering support, safety incident report summary. MRO system crew management safety management integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const AVIATION_SYSTEMS = "MRO System, Crew Management, Safety Management, Document Management, Email, Power BI";

const RAW = [
  {
    id: "mro-work-order-planning",
    subIndustry: "MRO",
    department: "Planning",
    businessProcess: "MRO work order planning",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "MRO work order planning",
    title: "Mro Work Order Planning Automation for Aviation & Aerospace",
    seoKeywords: "aviation & aerospace, mro work order planning, AI automation, RPA, agentic AI",
    challenge: "Planners manually sequence work orders based on skills, parts, bays and aircraft availability.",
    solution: "Implement Agentic AI + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "MRO teams can improve mro work order planning with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "MRO Head, Planning Head",
    systems: AVIATION_SYSTEMS,
    agentsRequired: "MRO AI Agent, Validation Agent, Human Review Agent",
    inputData: "Emails, forms, system records, task notes, master data and mro work order planning process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for mro work order planning",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "12+ months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "safety-incident-report-summary",
    subIndustry: "Aviation Safety",
    department: "Safety",
    businessProcess: "Safety incident report summary",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Safety incident report summary",
    title: "Safety Incident Report Summary Automation for Aviation & Aerospace",
    seoKeywords: "aviation & aerospace, safety incident report summary, AI automation, RPA, agentic AI, document AI",
    challenge: "Safety teams manually summarize incident reports, corrective actions and evidence.",
    solution: "Implement Agentic AI + Document AI to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Aviation Safety teams can improve safety incident report summary with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Document AI",
    buyerPersona: "Safety Head",
    systems: AVIATION_SYSTEMS,
    agentsRequired: "Document Extraction Agent, Safety Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and safety incident report summary rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready safety incident report summary record",
    keyBenefits: "Stronger Controls, Faster Review, Clearer Audit Trail And Fewer Missed Exceptions",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const AVIATION_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["MRO", "Aviation Safety"];
export const AVIATION_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => AVIATION_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'aviation-domain', domainIntro: AVIATION_DOMAIN_INTRO, useCases: AVIATION_USE_CASES });
export const AVIATION_USE_CASES_SEO = seo.useCasesSeo;
export const AVIATION_DOMAIN_FAQS = seo.domainFaqs;
export const AVIATION_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const AVIATION_FAQ_JSONLD = seo.faqJsonLd;
export const AVIATION_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const AVIATION_WEBPAGE_JSONLD = seo.webPageJsonLd;

